import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modal } from 'src/app/shared/modals/modal';
import { ModalHeaderComponent } from 'src/app/shared/modals/components/modal-header/modal-header.component';
import { HourRateFgComponent, IHourRateFG, getHourRateFG } from 'src/app/shared/components/hour-rate-fg/hour-rate-fg.component';
import { FormGroup } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-hour-rate-modal',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule, TranslateModule,
    ModalHeaderComponent, HourRateFgComponent,
  ],
  templateUrl: './hour-rate-modal.component.html',
  styleUrls: ['./hour-rate-modal.component.scss']
})
export class HourRateModalComponent extends Modal {

  internalFG: FormGroup<IHourRateFG> = getHourRateFG();

  _FG: FormGroup<IHourRateFG> | undefined;
  get FG () { return this._FG; };
  @Input() set FG(c: FormGroup<IHourRateFG> | undefined) {
    this._FG = c;
    if (c) {
      this.internalFG.patchValue(c.value);
    }
  }

  onSubmit() {
    this.FG?.patchValue(this.internalFG.value);
    this.close();
  }
}
